import { initialPagination } from '@components/shared/Table/components/Pagination/types'
import { parseGetClByUserCodePayload } from '../helpers/parseGetClByUserCodePayload'
import { parseGetUsersPayload } from '../helpers/parseGetUsersPayload'
import { parseSaveUserProfilePayload } from '../helpers/parseSaveUserProfilePayload'
import { toast } from '@utils/functions/notificationToast'
import { useUser } from '@hooks/useUser'
import { useUsers } from '.'

import type { AxiosError } from 'axios'
import type { GetClByUserCodePayloadProps, UserDataModalFormProps } from './types'
import type { GetClDetailsRequestProps } from '@services/api/users/types'
import type { UserDataFormProps } from '../components/UserDataModal/components/RegistrationDataForm/form/types'

import * as apiUsers from '@services/api/users'

const updateUserAdmin = async (userId: number, isAdmin: boolean) => {
  const { setIsUpdateUserAdminLoading } = useUsers.getState()
  const { userData, getUserPermissions } = useUser.getState()

  setIsUpdateUserAdminLoading(true)

  try {
    await apiUsers.updateUserAdmin(userId, isAdmin)

    toast.success('Usuário atualizado com sucesso!')

    getUserPermissions(userData?.user.id!)
  } catch (error) {
    toast.error('Falha ao atualizar o usuário!', (error as AxiosError)?.status)
  } finally {
    setIsUpdateUserAdminLoading(false)
  }
}

const saveUserProfile = async (params: UserDataFormProps) => {
  const { setIsSaveUserProfileLoading } = useUsers.getState()

  setIsSaveUserProfileLoading(true)

  try {
    const payload = parseSaveUserProfilePayload(params)

    await apiUsers.saveUserProfile(payload)

    toast.success('Perfil do usuário salvo com sucesso!')

    getUsers({
      page: initialPagination.PAGE,
      itemsPerPage: initialPagination.ITEMS_PER_PAGE
    })
  } catch (error) {
    toast.error('Falha ao salvar o perfil do usuário!', (error as AxiosError)?.status)
  } finally {
    setIsSaveUserProfileLoading(false)
  }
}

const getClDetails = async (params: GetClDetailsRequestProps) => {
  const { setClDetailsData, setIsClDetailsLoading } = useUsers.getState()

  setIsClDetailsLoading(true)

  try {
    const data = await apiUsers.getClDetails(params)

    setClDetailsData(data)
  } catch (error) {
    toast.error('Falha ao buscar os detalhes do centro de lucro!', (error as AxiosError)?.status)
  } finally {
    setIsClDetailsLoading(false)
  }
}

const getClByUserCode = async (formData: GetClByUserCodePayloadProps) => {
  const { setClByUserCodeData, setIsClByUserCodeLoading } = useUsers.getState()

  setIsClByUserCodeLoading(true)

  try {
    const payload = parseGetClByUserCodePayload(formData)

    const data = await apiUsers.getClByUserCode(payload)

    setClByUserCodeData(data)
  } catch (error) {
    toast.error('Falha ao buscar o centro de lucro do usuário!', (error as AxiosError)?.status)
  } finally {
    setIsClByUserCodeLoading(false)
  }
}

const getUsers = async (formData: UserDataModalFormProps) => {
  const { setUsersData, setIsUsersLoading } = useUsers.getState()

  setIsUsersLoading(true)

  try {
    const payload = parseGetUsersPayload(formData)

    const data = await apiUsers.getUsers(payload)

    setUsersData(data)
  } catch (error) {
    toast.error('Falha ao buscar os usuários!', (error as AxiosError)?.status)
  } finally {
    setIsUsersLoading(false)
  }
}

export { getUsers, getClByUserCode, getClDetails, saveUserProfile, updateUserAdmin }
